export default {
    name : 'header',

    init()
    {
        this.toggleSearch();
    },

    toggleSearch()
    {
        const el = document.querySelector('.js_toggle-search');

        el.addEventListener('click', () => {
            document.querySelector('.header').classList.toggle('active-search')
            document.getElementById('site-navigation').classList.remove('toggled');
        });
    },

} // export